var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"summary-detail"},[_c('v-col',[_c('div',{staticClass:"text-700 group-title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }